export const promoCodesTabs = [
  { id: 1, title: "Non-Personal", value: false },
  { id: 2, title: "Personal", value: true }
];
